import { Badge, FluentProvider, Text } from "@fluentui/react-components";
import * as React from "react";
import StringsStore from "sh-strings/store";
import ThemeUtils from "../../../utility/ThemeUtils";

export const NewBadge = () => {
    const _strings = StringsStore().registeredStringModules.get("header").strings;

    return (
        <FluentProvider theme={ThemeUtils.getFluentV2ShiftTheme()} style={{ backgroundColor: "var(--transparent-background)" }}>
            <Badge
                id="NewBadgeLabel"
                appearance="tint"
                color="brand"
                size="medium"
                shape="circular"
                aria-label={_strings.get("newBadgeText")}
                style={{ marginLeft: "8px" }}
            >
                <Text size={100} weight="semibold">{_strings.get("newBadgeText")}</Text>
            </Badge>
        </FluentProvider>
    );
};